import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {accountSearchResultResultSelector} from '../../slices/account-search-result.slice';

type Props = {
    accountId: number,
};

export const SsoEnabledCell = ({accountId}: Props) => {
    const result = useSelector(accountSearchResultResultSelector);

    const value = useMemo(() => {
        const account = result?.data.find(a => a.accountId === accountId);
        if (!account || account.ssoEnabled === undefined) {
            return undefined;
        }
        return account.ssoEnabled ? 'Yes' : 'No';
    }, [result, accountId]);

    if (!value) {
        return null;
    }

    return (
        <span>{value}</span>
    );
};
